/**
 * external dependencies
 */
var forge = require('node-forge');

const encryptData = (data: string) => {
  const publicKeyString = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAof+vW9kPxBN+KOvDbwyz
aaA6TVSDAU0nAbfYmHS6g7LnMgLHHiP+vZq41M7l2BrvKygkAnsO+AGHyqvLVR8u
57MFABViR9+XK8uhxjM31Zu3FxCPBl/r2YAm8235GEug+eGYQg9OYI/0LwOibhHv
tX3OGKTBcJEfgAt2WpjO8sybN8fYzMOHUC7xn+k/trk3Bx3qCoG22eeu3sdEu9wO
SSAD/WYAkE8UKddNuKXmrGXo5HLi7LswATTvnk0vXzi4Y1ECGvI2UpTU2GiPuKmn
ugvCWQ8VDjNg+/rMqn2WGvgiX6CXLTZvOcFkUPQdQeoqWtcF4lstq+sJedauts5H
GwIDAQAB
-----END PUBLIC KEY-----`;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyString);
  const encrypted = publicKey.encrypt(data, "RSA-OAEP", { 
    md: forge.md.sha1.create(),
    mgf1: {
      md: forge.md.sha1.create(),
    }
  });

  const encryptedData = forge.util.encode64(encrypted);
 
  return encryptedData;
};

/**
 * internal dependencies
 */
import { wpApiInstance} from '../api/wp-api';

import { IAwsSignIn, I_WP_LOGIN } from '../models/login.interface';

const WpAuthorizeUser = async (userCreds: IAwsSignIn) => {
  try {
    const formattedDAta = `${userCreds.user}:${userCreds.pass}`;
    const token = encryptData(formattedDAta);
    const { data } = await wpApiInstance.post('/portal', {
      request: token
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if ( data.statusCode >= 400 && data.statusCode <= 500 ) {
      throw data.body;
    }

    return data;
  } catch(error: any) {
    throw error;
  }
};

const WPLogoutUser = async () => {};

export { WpAuthorizeUser };